(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6],{

/***/ 5579:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "B": function() { return /* binding */ Registry; },
  "n": function() { return /* binding */ container_registry_container; }
});

// EXTERNAL MODULE: ./node_modules/reflect-metadata/Reflect.js
var Reflect = __webpack_require__(8660);
// EXTERNAL MODULE: ./node_modules/inversify/es/container/container.js + 35 modules
var container = __webpack_require__(7089);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(2777);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(2262);
;// CONCATENATED MODULE: ./src/@core/application/post/get-post.use-case.ts


//Dependency Inversion
var GetPostUseCase = /*#__PURE__*/function () {
  function GetPostUseCase(postGate) {
    (0,classCallCheck/* default */.Z)(this, GetPostUseCase);

    this.postGate = postGate;
  }

  (0,createClass/* default */.Z)(GetPostUseCase, [{
    key: "execute",
    value: function execute(slug) {
      return this.postGate.findBySlug(slug);
    }
  }]);

  return GetPostUseCase;
}();
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(29);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(7794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
;// CONCATENATED MODULE: ./src/@core/application/post/list-posts.use-case.ts




var ListPostsUseCase = /*#__PURE__*/function () {
  function ListPostsUseCase(postGate) {
    (0,classCallCheck/* default */.Z)(this, ListPostsUseCase);

    this.postGate = postGate;
  }

  (0,createClass/* default */.Z)(ListPostsUseCase, [{
    key: "execute",
    value: function () {
      var _execute = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(params) {
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", this.postGate.findAll(params));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function execute(_x) {
        return _execute.apply(this, arguments);
      }

      return execute;
    }()
  }]);

  return ListPostsUseCase;
}();
;// CONCATENATED MODULE: ./src/helpers/post-reading-time.ts
function readingTime(content) {
  var text = content;
  var wpm = 225;
  var words = text.trim().split(/\s+/).length;
  var time = Math.ceil(words / wpm);
  return time;
}
;// CONCATENATED MODULE: ./src/@core/domain/entities/post.ts


var Post = /*#__PURE__*/function () {
  function Post(props) {
    (0,classCallCheck/* default */.Z)(this, Post);

    this.props = props;
  }

  (0,createClass/* default */.Z)(Post, [{
    key: "id",
    get: function get() {
      return this.props.id;
    }
  }, {
    key: "slug",
    get: function get() {
      return this.props.slug;
    }
  }, {
    key: "title",
    get: function get() {
      return this.props.title;
    }
  }, {
    key: "description",
    get: function get() {
      return this.props.description;
    }
  }, {
    key: "content",
    get: function get() {
      return this.props.content;
    }
  }, {
    key: "category",
    get: function get() {
      return this.props.category;
    }
  }, {
    key: "date",
    get: function get() {
      return this.props.date;
    }
  }, {
    key: "media",
    get: function get() {
      return this.props.media;
    }
  }, {
    key: "authorId",
    get: function get() {
      return this.props.authorId;
    }
  }, {
    key: "readingTime",
    get: function get() {
      return this.props.readingTime;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var _this$content;

      return {
        id: this.id,
        slug: this.slug,
        title: this.title,
        description: this.description,
        content: (_this$content = this.content) !== null && _this$content !== void 0 ? _this$content : null,
        category: this.category,
        date: this.date,
        media: this.media,
        authorId: this.authorId,
        readingTime: this.readingTime
      };
    }
  }]);

  return Post;
}();
;// CONCATENATED MODULE: ./src/@core/infra/gateways/post-http.gateway.ts






var PostHttpGateway = /*#__PURE__*/function () {
  function PostHttpGateway(http) {
    (0,classCallCheck/* default */.Z)(this, PostHttpGateway);

    this.http = http;
  }

  (0,createClass/* default */.Z)(PostHttpGateway, [{
    key: "findAll",
    value: function () {
      var _findAll = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(params) {
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", this.http.get('/wp/v2/posts', {
                  params: params
                }).then(function (res) {
                  return res.data.map(function (data) {
                    return new Post({
                      id: data.id,
                      slug: data.slug,
                      title: data.title.rendered,
                      description: data.excerpt.rendered,
                      category: data.categories[0],
                      content: null,
                      date: data.date,
                      media: data.jetpack_featured_media_url,
                      authorId: data.author,
                      readingTime: readingTime(data.content.rendered)
                    }).toJSON();
                  });
                })["catch"](function (err) {
                  return err;
                }));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function findAll(_x) {
        return _findAll.apply(this, arguments);
      }

      return findAll;
    }()
  }, {
    key: "findBySlug",
    value: function () {
      var _findBySlug = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(slug) {
        var params;
        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                params = {
                  slug: slug
                };
                return _context2.abrupt("return", this.http.get("/wp/v2/posts", {
                  params: params
                }).then(function (res) {
                  var data = res.data.shift();
                  return new Post({
                    id: data.id,
                    slug: data.slug,
                    title: data.title.rendered,
                    description: data.excerpt.rendered,
                    content: data.content.rendered,
                    category: data.categories[0],
                    date: data.date,
                    media: data.jetpack_featured_media_url,
                    authorId: data.author,
                    readingTime: readingTime(data.content.rendered)
                  }).toJSON();
                })["catch"](function (err) {
                  return err;
                }));

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function findBySlug(_x2) {
        return _findBySlug.apply(this, arguments);
      }

      return findBySlug;
    }()
  }, {
    key: "listMostSeenPosts",
    value: function () {
      var _listMostSeenPosts = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3() {
        return regenerator_default().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", this.http.get('/wp_query/args?meta_key=post_views_count&orderby=meta_value_num&posts_per_page=4&ignore_sticky_posts=true').then(function (res) {
                  return res.data.map(function (data) {
                    return new Post({
                      id: data.id,
                      slug: data.slug,
                      title: data.title.rendered,
                      description: data.excerpt.rendered,
                      category: data.categories[0],
                      content: null,
                      date: data.date,
                      media: data.jetpack_featured_media_url,
                      authorId: data.author,
                      readingTime: readingTime(data.content.rendered)
                    }).toJSON();
                  });
                })["catch"](function (err) {
                  return err;
                }));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function listMostSeenPosts() {
        return _listMostSeenPosts.apply(this, arguments);
      }

      return listMostSeenPosts;
    }()
  }]);

  return PostHttpGateway;
}();
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
;// CONCATENATED MODULE: ./src/@core/infra/http.ts

var http = axios_default().create({
  baseURL: "https://kenzie.com.br/blog/wp-json"
});
;// CONCATENATED MODULE: ./src/@core/domain/entities/author.ts


var Author = /*#__PURE__*/function () {
  function Author(props) {
    (0,classCallCheck/* default */.Z)(this, Author);

    this.props = props;
  }

  (0,createClass/* default */.Z)(Author, [{
    key: "id",
    get: function get() {
      return this.props.id;
    }
  }, {
    key: "name",
    get: function get() {
      return this.props.name;
    }
  }, {
    key: "avatarUrl",
    get: function get() {
      return this.props.avatarUrl;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        id: this.id,
        name: this.name,
        avatarUrl: this.avatarUrl
      };
    }
  }]);

  return Author;
}();
;// CONCATENATED MODULE: ./src/@core/infra/gateways/author-http.gateway.ts





var AuthorHttpGateway = /*#__PURE__*/function () {
  function AuthorHttpGateway(http) {
    (0,classCallCheck/* default */.Z)(this, AuthorHttpGateway);

    this.http = http;
  }

  (0,createClass/* default */.Z)(AuthorHttpGateway, [{
    key: "findById",
    value: function () {
      var _findById = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(id) {
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", this.http.get("/wp/v2/users/".concat(id)).then(function (res) {
                  return new Author({
                    id: res.data.id,
                    name: res.data.name,
                    avatarUrl: res.data.avatar_urls['96']
                  });
                }));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function findById(_x) {
        return _findById.apply(this, arguments);
      }

      return findById;
    }()
  }]);

  return AuthorHttpGateway;
}();
;// CONCATENATED MODULE: ./src/@core/application/author/get-author.use-case.ts


//Dependency Inversion
var GetAuthorUseCase = /*#__PURE__*/function () {
  function GetAuthorUseCase(authorGate) {
    (0,classCallCheck/* default */.Z)(this, GetAuthorUseCase);

    this.authorGate = authorGate;
  }

  (0,createClass/* default */.Z)(GetAuthorUseCase, [{
    key: "execute",
    value: function execute(id) {
      return this.authorGate.findById(id);
    }
  }]);

  return GetAuthorUseCase;
}();
;// CONCATENATED MODULE: ./src/@core/application/post/list-most-seen-posts.ts




var ListMostSeenPostsUseCase = /*#__PURE__*/function () {
  function ListMostSeenPostsUseCase(postGate) {
    (0,classCallCheck/* default */.Z)(this, ListMostSeenPostsUseCase);

    this.postGate = postGate;
  }

  (0,createClass/* default */.Z)(ListMostSeenPostsUseCase, [{
    key: "execute",
    value: function () {
      var _execute = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", this.postGate.listMostSeenPosts());

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function execute() {
        return _execute.apply(this, arguments);
      }

      return execute;
    }()
  }]);

  return ListMostSeenPostsUseCase;
}();
;// CONCATENATED MODULE: ./src/@core/infra/container-registry.ts









var Registry = {
  AxiosAdapter: Symbol["for"]('AxiosAdapter'),
  PostGateway: Symbol["for"]('PostGateway'),
  AuthorGateway: Symbol["for"]('AuthorGateway'),
  ListPostsUseCase: Symbol["for"]('ListPostsUseCase'),
  GetPostUseCase: Symbol["for"]('GetPostUseCase'),
  ListMostSeenPostsUseCase: Symbol["for"]('ListMostSeenPostsUseCase'),
  GetAuthorUseCase: Symbol["for"]('GetAuthorUseCase')
};
var container_registry_container = new container/* Container */.W(); //########## HTTP

container_registry_container.bind(Registry.AxiosAdapter).toConstantValue(http); //########## GATEWAYS

container_registry_container.bind(Registry.PostGateway).toDynamicValue(function (context) {
  return new PostHttpGateway(context.container.get(Registry.AxiosAdapter));
});
container_registry_container.bind(Registry.AuthorGateway).toDynamicValue(function (context) {
  return new AuthorHttpGateway(context.container.get(Registry.AxiosAdapter));
}); //########## USE CASES

container_registry_container.bind(Registry.ListPostsUseCase).toDynamicValue(function (context) {
  return new ListPostsUseCase(context.container.get(Registry.PostGateway));
});
container_registry_container.bind(Registry.GetPostUseCase).toDynamicValue(function (context) {
  return new GetPostUseCase(context.container.get(Registry.PostGateway));
});
container_registry_container.bind(Registry.ListMostSeenPostsUseCase).toDynamicValue(function (context) {
  return new ListMostSeenPostsUseCase(context.container.get(Registry.PostGateway));
});
container_registry_container.bind(Registry.GetAuthorUseCase).toDynamicValue(function (context) {
  return new GetAuthorUseCase(context.container.get(Registry.AuthorGateway));
});

/***/ }),

/***/ 5802:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CustomPagination; }
/* harmony export */ });
/* harmony import */ var _mui_material_Pagination__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1330);
/* harmony import */ var _mui_material_Stack__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9144);
/* harmony import */ var _mui_material_useMediaQuery__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1225);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2125);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);





var Container = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "CustomPagination__Container",
  componentId: "sc-140aqx9-0"
})([".MuiPagination-ul{max-width:100%;}.MuiPaginationItem-root{font-weight:700 !important;&:hover{background:#d2d2d2 !important;}}.Mui-selected{background:var(--highlight-blue) !important;&:hover{background:var(--highlight-blue) !important;}}"]);
function CustomPagination(_ref) {
  var handleChange = _ref.handleChange,
      page = _ref.page,
      _ref$count = _ref.count,
      count = _ref$count === void 0 ? 1 : _ref$count;
  var isMobile = (0,_mui_material_useMediaQuery__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)('(max-width: 540px)');
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Container, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Stack__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
      spacing: 1,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Pagination__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        count: count,
        size: isMobile ? 'small' : 'medium',
        page: page,
        color: "primary",
        onChange: handleChange
      })
    })
  });
}

/***/ }),

/***/ 6711:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Category; }
});

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/components/Header/index.tsx + 3 modules
var Header = __webpack_require__(98);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(29);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(7794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./src/@core/infra/container-registry.ts + 10 modules
var container_registry = __webpack_require__(5579);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/components/CustomPagination/index.tsx
var CustomPagination = __webpack_require__(5802);
// EXTERNAL MODULE: ./src/components/PostCard/index.tsx + 2 modules
var PostCard = __webpack_require__(9252);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(2125);
;// CONCATENATED MODULE: ./src/components/CategoryPostsList/styles.ts

var Container = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "styles__Container",
  componentId: "sc-sb1dh8-0"
})(["padding-top:2.5rem;margin:0 auto;@media (min-width:1024px){padding:4.25rem 0 0;}"]);
var List = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "styles__List",
  componentId: "sc-sb1dh8-1"
})(["display:flex;flex-wrap:wrap;justify-content:flex-start;gap:2.5rem 3.6rem;margin:0 auto;@media (max-width:1200px){gap:1.5rem 3rem;justify-content:center;}"]);
var PaginationContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__PaginationContainer",
  componentId: "sc-sb1dh8-2"
})(["margin:0 auto;padding:4.5rem 0 2.5rem;width:fit-content;"]);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./src/components/CategoryPostsList/index.tsx









function CategoryPostsList(_ref) {
  var posts = _ref.posts,
      categoryId = _ref.categoryId,
      postsCount = _ref.postsCount;

  var _useState = (0,react.useState)(posts),
      postsList = _useState[0],
      setPostsList = _useState[1];

  var _useState2 = (0,react.useState)(1),
      page = _useState2[0],
      setPage = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      isLoading = _useState3[0],
      setIsLoading = _useState3[1];

  var ref = (0,react.useRef)(null);
  var roundedCount = Math.round(postsCount / 12);

  function scrollToRef() {
    if (ref.current) window.scrollTo({
      top: ref.current.offsetTop - 180
    });
  }

  var fetchPosts = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(page, categoryId) {
      var listPostsUseCase, posts;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              listPostsUseCase = container_registry/* container.get */.n.get(container_registry/* Registry.ListPostsUseCase */.B.ListPostsUseCase);
              _context.next = 3;
              return listPostsUseCase.execute({
                per_page: 12,
                page: page,
                categories: categoryId
              });

            case 3:
              posts = _context.sent;
              return _context.abrupt("return", posts);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchPosts(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleChange = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(event, value) {
      var posts;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setIsLoading(true);
              setPage(value);
              _context2.next = 4;
              return fetchPosts(value, categoryId);

            case 4:
              posts = _context2.sent;
              setPostsList(posts);
              setIsLoading(false);
              scrollToRef();

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleChange(_x3, _x4) {
      return _ref3.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Container, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(List, {
      children: postsList.map(function (post, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(PostCard/* default */.Z, {
          post: post,
          showCategory: false,
          isLoading: isLoading
        }, index);
      })
    }), roundedCount > 1 ? /*#__PURE__*/(0,jsx_runtime.jsx)(PaginationContainer, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(CustomPagination/* default */.Z, {
        handleChange: handleChange,
        page: page,
        count: Math.round(postsCount / 12)
      })
    }) : null, ' ']
  });
}
// EXTERNAL MODULE: ./src/components/CategoriesSection/index.tsx + 3 modules
var CategoriesSection = __webpack_require__(6651);
;// CONCATENATED MODULE: ./src/styles/pages/category.ts

var TitleContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "category__TitleContainer",
  componentId: "sc-ue5p3m-0"
})(["display:flex;align-items:center;gap:1rem;padding:6.55rem 0 1rem;@media (min-width:1024px){gap:2rem;}"]);
var CategoryTag = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
  displayName: "category__CategoryTag",
  componentId: "sc-ue5p3m-1"
})(["display:flex;justify-content:center;align-items:center;font-weight:800;background:", ";font-size:1rem;color:var(--text-color-secondary);text-transform:uppercase;padding:0rem 0.5rem;height:2rem;@media (min-width:1024px){font-size:1.25rem;height:2.5rem;padding:0rem 1rem;}"], function (_ref) {
  var background = _ref.background;
  return background && background;
});
var CategoryPrev = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "category__CategoryPrev",
  componentId: "sc-ue5p3m-2"
})(["font-family:'JetBrains Mono',sans-serif;font-size:1.625rem;font-weight:800;color:var(--highlight-blue);text-transform:uppercase;@media (min-width:1024px){font-size:3rem;}"]);
var Content = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "category__Content",
  componentId: "sc-ue5p3m-3"
})(["padding:2.5rem 0;width:85%;max-width:var(--max-width);border-bottom:1px solid #dddddd;margin:0 auto;@media (min-width:1024px){padding:4.25rem 0;max-width:1170px;}"]);
;// CONCATENATED MODULE: ./src/pages/categorias/[slug].tsx








var __N_SSG = true;
function Category(_ref) {
  var posts = _ref.posts,
      category = _ref.category,
      postsCount = _ref.postsCount;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("title", {
        children: ["Posts sobre ", category.name, " | Kenzie Academy"]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: ""
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "twitter:title",
        content: "Kenzie Academy Brasil: Curso de Programa\xE7\xE3o Online"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "twitter:description",
        content: "Torne-se um desenvolvedor em 12 meses com o curso de programa\xE7\xE3o online da Kenzie Academy Brasil e comece a pagar ap\xF3s estar empregado. Confira!"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:title",
        content: "Kenzie Academy Brasil: Curso de Programa\xE7\xE3o Online"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "canonical",
        href: "https://kenzie.com.br/blog/categorias/".concat(category.name)
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Header/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)("main", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Content, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TitleContainer, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CategoryPrev, {
            children: "Categoria"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(CategoryTag, {
            background: category.color,
            children: category.name
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(CategoryPostsList, {
          posts: posts,
          categoryId: category.id,
          postsCount: postsCount
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(CategoriesSection/* default */.Z, {})]
    })]
  });
}

/***/ }),

/***/ 2344:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/categorias/[slug]",
      function () {
        return __webpack_require__(6711);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [692,352,100,450,774,888,179], function() { return __webpack_exec__(2344); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);